export class DocumentRepository {
    uploadFile(UploadInfo) {
      throw new Error('Upload file method not implemented');
    }
    UpdateDocument(UpdateDocRequest) {
      throw new Error('UpdateDocument method not implemented');
    }
  }